import type { DesktopDeviceApprovalNotice } from './desktop-device-approval';

export type DesktopDeviceApprovalBridge = {
  version: 1;
  subscribeDeviceApproval(
    listener: (notice: DesktopDeviceApprovalNotice | null) => void
  ): () => void;
};
export function readDesktopDeviceApprovalSubscription(value: unknown) {
  if (
    !value ||
    typeof value !== 'object' ||
    !('version' in value) ||
    value.version !== 1 ||
    !('subscribeDeviceApproval' in value) ||
    typeof value.subscribeDeviceApproval !== 'function'
  )
    return null;
  const subscribe = value.subscribeDeviceApproval;
  return (listener: (notice: DesktopDeviceApprovalNotice | null) => void) => {
    const unsubscribe: unknown = subscribe(listener);
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  };
}
